const advantages = [
  {
    title: "Multiempresa e grupos",
    description: "Isolamento total por CNPJ com RLS no PostgreSQL e papéis RBAC.",
  },
  {
    title: "Auditoria de tudo",
    description: "Cada ação gera registro com HMAC — compliance, suporte e LGPD.",
  },
  {
    title: "API assíncrona 202",
    description: "Seu ERP enfileira a emissão e segue o fluxo; a SEFAZ não trava sua operação.",
  },
  {
    title: "Certificado seguro",
    description: "Envelope AES-256-GCM; senha do A1 nunca persiste em texto claro.",
  },
  {
    title: "Homolog e produção",
    description: "Slots e filas separados por ambiente — teste antes de ir ao ar.",
  },
  {
    title: "IA local (opt-in)",
    description: "Sugestão NCM com embedding + pgvector; OpenAI desligado por padrão.",
  },
]

export const AdvantagesSection = () => {
  return (
    <section id="vantagens" className="bg-slate-50 py-16 sm:py-20">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <h2 className="text-3xl font-bold text-slate-900">Vantagens</h2>
        <p className="mt-3 max-w-2xl text-slate-600">
          ERPs precisam de NFe confiável, auditada e multi-CNPJ. O FiscalHub foi desenhado como HUB central,
          não como biblioteca solta.
        </p>
        <div className="mt-10 grid gap-5 md:grid-cols-2">
          {advantages.map((item) => (
            <div key={item.title} className="flex gap-4 rounded-xl border border-slate-200 bg-white p-5">
              <div className="mt-1 h-2 w-2 shrink-0 rounded-full bg-brand-600" aria-hidden="true" />
              <div>
                <h3 className="font-semibold text-slate-900">{item.title}</h3>
                <p className="mt-1 text-sm text-slate-600">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
